import LegalShell from "./LegalShell";

export default function About() {
  return (
    <LegalShell eyebrow="About StyleMe" title="An AI atelier, for him & her.">
      <p>
        StyleMe is an AI personal stylist that helps anyone — bride, groom, professional or partygoer —
        compose a complete look in seconds: outfit, hair, makeup and a colour palette,
        visualised on their own portrait.
      </p>
      <p>
        We blend the latest generative AI with editorial taste, so the suggestions feel
        less like a search result and more like advice from a thoughtful friend who happens
        to be a stylist. Every recommendation is informed by your gender, body shape, skin tone
        and the occasion — never one-size-fits-all.
      </p>

      <h2>Founded 2026, India</h2>
      <p>
        StyleMe began with a simple frustration: getting dressed for any meaningful occasion
        — a wedding, an interview, an evening out — is rarely effortless. There are too many
        rules, too much noise, and not enough taste. We wanted to put a confident, considered
        stylist in everyone's pocket.
      </p>

      <h2>What we care about</h2>
      <ul>
        <li><b>Taste over trends.</b> Recommendations rooted in lasting style, not the algorithm of the week.</li>
        <li><b>Both men and women.</b> The app is built for everyone, with looks tailored individually rather than as default-female.</li>
        <li><b>Privacy by default.</b> Uploaded photos are processed in real-time and deleted immediately after generation.</li>
        <li><b>Indian first, global next.</b> Sarees and sherwanis are first-class citizens, not afterthoughts.</li>
      </ul>

      <h2>Get in touch</h2>
      <p>
        For partnerships, press or just to say hello — write to <a href="mailto:srichandrab@stylenme.com">srichandrab@stylenme.com</a>.
      </p>
    </LegalShell>
  );
}
